import { gate } from 'hub-http/gates';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { useIsSuperAdmin } from './hooks/useIsSuperAdmin';
import { Text } from 'foundations-components/components/Text';
import { getFullUrl } from 'hubspot-url-utils';
import { BreezeTertiaryAIBaseButton } from 'ai-components-ui-library/components/buttons/internal/styledButtons/StyledAIBaseButton';
import AILink from 'ai-components-ui-library/components/buttons/AILink';
import PortalIdParser from 'PortalIdParser';
import { useShouldShowCopilotPreviews } from '../../../hooks/useShouldShowCopilotPreviews';
import { useIsUngatedForCopilotV2 } from 'ai-components-ui-library/hooks/useIsUngatedForCopilotV2';
import { useIsUngated } from 'ai-components-ui-library/hooks/useIsUngated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DisabledPreviewControls = ({
  usageTracker,
  onDontShowAgain,
  isDisabledDescriptionOverriden
}) => {
  const isSuperAdmin = useIsSuperAdmin();
  const aiSettingsLink = `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;
  const {
    setDontShowAgain
  } = useShouldShowCopilotPreviews({
    overrideDisabled: true
  });
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  const isUngatedForCopilotPreviewsV2 = useIsUngated(gate('Copilot:PreviewsV2'));
  const handleDontShowAgain = () => {
    setDontShowAgain();
    usageTracker.track('Ai Addon Copilot Preview', 'Copilot Preview Interaction', {
      action: 'dont_show_again',
      isCopilotV2Enabled: isUngatedForCopilotV2 && isUngatedForCopilotPreviewsV2
    });
    onDontShowAgain();
  };
  const handleSettingsLinkClick = () => {
    usageTracker.track('Ai Addon Copilot Preview', 'Copilot Preview Interaction', {
      action: 'settings_link_click',
      isCopilotV2Enabled: isUngatedForCopilotV2 && isUngatedForCopilotPreviewsV2
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    alignItems: "start",
    children: [isSuperAdmin && !isDisabledDescriptionOverriden && /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: /*#__PURE__*/_jsx(AILink, {
        href: aiSettingsLink,
        onClick: handleSettingsLinkClick,
        external: true,
        children: unescapedText('aiAddonCopilotPreview.components.disabledPreview.settingsLink')
      })
    }), /*#__PURE__*/_jsx(BreezeTertiaryAIBaseButton, {
      size: "xs",
      onClick: handleDontShowAgain,
      responsive: false,
      children: unescapedText('aiAddonCopilotPreview.components.disabledPreview.dontShowAgainButton')
    })]
  });
};